import React from 'react';
import {
  Create,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
} from 'react-admin';
import VisibilityInput from '../components/VisibilityInput';

const LeaderboardCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput source="world_id" reference="worlds" allowEmpty>
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput source="name" />
      <VisibilityInput />
    </SimpleForm>
  </Create>
);

export default LeaderboardCreate;
